export const SET_CONFIG = 'APP/SET_CONFIG'
